module.exports = __webpack_public_path__ + "static/korea-logo-d7c264d2719a1e070d3a219ba24b08de.png";